import React, { useEffect } from "react";
import "./privacy-policy.css";

const PrivacyPolicy = () => {
  // 🔴 ADDED: PAGE HAMESHA TOP SE OPEN HOGA
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant", // smooth chahiye to "smooth"
    });
  }, []);

  return (
    <div className="privacy-wrapper">
      <div className="privacy-card">
        <h2 className="privacy-title">Privacy Policy :</h2>

        <p>
          Your privacy is important to us, and we are committed to protecting
          your personal information. This Privacy Policy outlines how we
          collect, use, and safeguard the information you provide when using our
          website.
        </p>

        <p>
          <strong>a. Information We Collect:</strong> We may collect personal
          information such as your name, contact details, and address when you
          use our website, especially during the product booking process.
          Non-personal information such as browser type, IP address, and device
          information may be automatically collected for analytical purposes.
        </p>

        <p>
          <strong>b. How We Use Your Information:</strong> Personal information
          is primarily used to process product bookings, communicate with you
          about your orders, and provide a personalized experience. Non-personal
          information is used for website analytics to enhance user experience
          and improve our services.
        </p>

        <p>
          <strong>c. Security:</strong> We employ industry-standard security
          measures to protect your personal information from unauthorized
          access, disclosure, alteration, and destruction.
        </p>

        <p>
          <strong>d. Third-Party Services:</strong> We may use third-party
          services for payment processing and analytics. These services have
          their own privacy policies, and we encourage you to review them.
        </p>

        <p>
          <strong>e. Cookies:</strong> Our website may use cookies to enhance
          your browsing experience. You can choose to disable cookies in your
          browser settings, but this may affect certain functionalities.
        </p>

        <p>
          <strong>f. Your Choices:</strong> You have the right to review,
          update, or delete your personal information. Please contact us if you
          wish to exercise these rights.
        </p>

        <p>
          <strong>g. Updates to the Privacy Policy:</strong> We may update this
          Privacy Policy periodically. Any changes will be effective immediately
          upon posting, and we encourage you to review this page regularly.
        </p>

        <p>
          <strong>h. Contact Us:</strong> If you have any questions or concerns
          regarding this Privacy Policy, please contact us at{" "}
          <span className="privacy-contact">
            ujalaebikes@gmail.com / 8009539867,8009539047
          </span>
          .
        </p>

        <p className="privacy-note">
          <strong>Note: Compliance with IT Act, 2000:</strong> We adhere to the
          provisions of the Information Technology Act, 2000, and other
          applicable laws governing the protection of personal information.
        </p>

        <p className="privacy-footer">
          By using our website, you agree to the terms outlined in this Privacy
          Policy. Thank you for trusting <strong>UJALA</strong>.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
